<template>
  <div class="rs-search">
    <RsFormInput
      placeholder="Search..."
      type="search"
    />
    <RsButton
      icon="search"
      variant="primary"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsSearch',
});
</script>
<style lang="scss">
  @import '@/styles/_variables.scss';
  .rs-search{
    display: flex;
    .rs-input{
      margin-bottom: 0;
      width: 100%;
      input{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }
    }
    .rs-button{
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
</style>
